import styled from 'styled-components'
import { HeightProps, height, SpaceProps, space, WidthProps, width } from 'styled-system'

import { Flex } from '@/atoms/layout'
import { filterLayoutProps } from '@/helpers/styled-props'

export const Section = styled(Flex).withConfig({
  shouldForwardProp: filterLayoutProps(),
})<WidthProps & SpaceProps & HeightProps>`
  flex-wrap: wrap;
  margin: 0 ${({ theme }) => `-${theme.space.S12}`};

  &:not(:first-child) {
    margin-top: ${({ theme }) => theme.space.S16};
  }

  ${width}
  ${space}
  ${height}
`
